import enLang from './entries/en_US';

const AppLocale = {
  en: enLang
};

export default AppLocale;
